import Vue from "vue";

export default {
    setDeliveryRequests(state, deliveryRequests) {
        state.deliveryRequests = deliveryRequests;
    },
    setSelectedDeliveryRequest(state, deliveryRequest) {
        state.selectedDeliveryRequest = deliveryRequest;
    },
    addDeliveryRequest(state, deliveryRequest) {
        if (!deliveryRequest) return;
        state.deliveryRequests.push(deliveryRequest);
    },
    updateDeliveryRequest(state, deliveryRequest) {
        const index = state.deliveryRequests.findIndex(
            (schedule) => schedule.id === deliveryRequest.id,
        );
        if (index !== -1) {
            Vue.set(state.deliveryRequests, index, {
                ...state.deliveryRequests[index],
                ...deliveryRequest,
            });
        }
    },
    updateSelectedDeliveryRequest(state, deliveryRequest) {
        state.selectedDeliveryRequest = {
            ...state.selectedDeliveryRequest,
            ...deliveryRequest,
        };
    },
};
